import hierarchyParser, { HierarchyItem } from '@riqra/hierarchy-parser'

import type { ILocality } from '~/types/localities'

type Locality = { [key in keyof ILocality]: ILocality[key] }

export default function getCoverageTree(dataSource: Locality[]): HierarchyItem<ILocality>[] {
  return hierarchyParser(dataSource, { identifier: 'originalId' })
}
